import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AutocompleteV3Service {
    /**
     * Filtra uma lista de itens baseado em um termo de busca
     */
    filterItems(items: string[], term: string, limit = 10): string[] {
        if (!term) return items;

        return items
            .filter(value => this._filterText(value, term))
            .slice(0, limit);
    }

    /**
     * Remove caracteres especiais e compara os textos
     */
    private _filterText(value: string, term: string): boolean {
        return (
            this._removeNonAlfaNumChars(value)
                ?.toLowerCase()
                .indexOf(this._removeNonAlfaNumChars(term).toLowerCase()) > -1
        );
    }

    /**
     * Remove caracteres especiais do texto
     */
    private _removeNonAlfaNumChars(text: string): string {
        return text?.normalize('NFD').replace(/[^a-zA-Z0-9\s]/g, '');
    }
}
